"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DECLARED = exports.LOWER = exports.GREATER = exports.BETWEEN = exports.REGEX = exports.CONTAINS = exports.EQUAL = void 0;
exports.EQUAL = 'equal';
exports.CONTAINS = 'contains';
exports.REGEX = 'regex';
exports.BETWEEN = 'between';
exports.GREATER = 'greater';
exports.LOWER = 'lower';
exports.DECLARED = 'declared';
//# sourceMappingURL=newConditions.js.map